export const USER_SAVE_DELETE_STATUS = -100;

export const USER_SAVE_INIT_STATUS = 0;
